import { request } from "@/service/request.js";


export function getGroupOrderRefundSingle(options) {
  return request.call(this, {
      url: "openapi/web/group/refund/list",
      method: 'POST',
      data:options
  });
}
